module.exports = __webpack_public_path__ + "media/swipe.3392692a.aac";